import styled from "styled-components";

import { GREEN } from "../../../styles";

export const Button = styled.button<any>`
  &, &:hover, &: focus {
    background-color: ${(props) => props.selected && GREEN};
    border-color: ${(props) => props.selected && GREEN};
    color: ${(props) => props.selected && "white"};
  }
  &&{
    padding: 8.5px 12px;
  }
  
  font-size: 100%;
`;
